"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUser = exports.useIsUserLoading = exports.useIsSignedIn = exports.useIsModalOpen = exports.useIsLoggedIn = exports.useIsAuthResolved = exports.useGetLogOut = exports.useGetIsLoggedIn = exports.useGetAccessToken = exports.useAuth = exports.useAppleAuth = exports.default = exports.Provider = exports.AuthProvider = exports.AuthConsumer = void 0;
var React = _interopRequireWildcard(require("react"));
var _cookies = require("@kiwicom/cookies");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _webMessageSchemas = require("@kiwicom/web-message-schemas");
var _Auth = require("../../records/Auth");
var api = _interopRequireWildcard(require("./api"));
var session = _interopRequireWildcard(require("../session/session"));
var tokenFns = _interopRequireWildcard(require("./token"));
var _loadSimpleTokenAuth = _interopRequireDefault(require("./services/loadSimpleTokenAuth"));
var _facebook = require("./services/facebook");
var _google = require("./services/google");
var _waitForVar = _interopRequireDefault(require("../utils/waitForVar"));
var _updateLocale = _interopRequireDefault(require("../../graphql/account/queries/updateLocale"));
var _events = require("../../consts/events");
var _client = require("../platform/client");
var _context = require("../log/context");
var _store = require("./api20/store");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const contextDefault = {
  auth: null,
  isSkyUsersV2: false,
  loading: false,
  state: "initial",
  modal: null,
  appleIdToken: null,
  appleUnconfirmedAuthToken: null,
  setAppleIdToken: () => {},
  onOpenModal: () => {},
  onCloseModal: () => {},
  onMyBooking: () => Promise.resolve(),
  onRegister: () => Promise.resolve(),
  onFacebookAuth: () => Promise.resolve(),
  onAppleAuth: () => Promise.resolve({
    connectAccount: false
  }),
  onGoogleAuth: () => Promise.resolve(),
  onSignIn: () => Promise.resolve(),
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  onSignOut: () => Promise.resolve(),
  logOut: () => Promise.resolve(),
  onSetAuth: () => null,
  onGetUserInfoAndLogin: () => Promise.resolve(),
  turnstileToken: null,
  disabledTurnstileAppId: null,
  setTurnstileToken: () => {},
  setDisabledTurnstileAppId: () => {},
  onTurnstileReset: () => {}
};
const context = /*#__PURE__*/React.createContext(contextDefault);
context.displayName = "AuthNitroContext";
const {
  Provider,
  Consumer: AuthConsumer
} = context;
exports.AuthConsumer = AuthConsumer;
exports.Provider = Provider;
const AuthProvider = _ref => {
  let {
    children,
    langInfo,
    brand,
    endpoint = api.Endpoint.PLEXUS,
    onMyBooking,
    onSignOut,
    isSkyUsersV2Enabled
  } = _ref;
  const [modal, setModal] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState("initial");
  const [auth, setAuth] = React.useState(null);
  const [appleIdToken, setAppleIdToken] = React.useState(null);
  const [appleUnconfirmedAuthToken, setAppleUnconfirmedAuthToken] = React.useState(null);
  const [isSkyUsersV2] = React.useState(() => {
    // Temp: we are disabling Skyusers v2 for Tequila until FE is migrated
    // Tequila iframe shares darwin config with MMB so we needed to use ui cookie
    if ((0, _client.isTequila)()) {
      return false;
    }
    // DEV cookie to simplify testing of SKYUSERS V2
    const devSkyusersV2EnabledCookie = (0, _cookies.load)("dev_skyusers_v2_enabled");
    if (devSkyusersV2EnabledCookie === "true") {
      return true;
    }
    return isSkyUsersV2Enabled;
  });
  const [turnstileToken, setTurnstileToken] = React.useState(null);
  const [disabledTurnstileAppId, setDisabledTurnstileAppId] = React.useState(null);
  const {
    log
  } = (0, _context.useLog)();
  const onSetAuth = React.useCallback(auth => {
    setAuth(auth);
    const cookieSaveOptions = {
      secure: process.env.NODE_ENV !== "development"
    };
    switch (auth.type) {
      case "user":
        break;
      case "token":
        // simple token has sense only when used with bid
        (0, _cookies.save)(_cookies.Cookie.SIMPLE_TOKEN, JSON.stringify(auth), cookieSaveOptions);
        // backward compatibility for old MMB
        _jsCookie.default.set(`simple_token-${auth.bid}`, auth.token, {
          ...cookieSaveOptions,
          expires: new Date(new Date().getTime() + 60 * 60 * 1000) // in 1 hour
        });
        break;
      default:
        // eslint-disable-next-line
        const pleaseBeExhaustiveForAuthType = auth;
        throw new Error(`NITRO: Unexpected auth type: ${JSON.stringify(auth)}`);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isSkyUsersV2]);
  const handleUpdateLocale = React.useCallback(auth => {
    if (auth.type === "user") {
      var _user$preferences, _user$preferences2;
      const {
        token,
        user
      } = auth;
      const currencyCookie = (0, _cookies.load)(_cookies.Cookie.CURRENCY);
      const currencyCookieUppercase = typeof currencyCookie === "string" ? currencyCookie.toUpperCase() : null;
      const isUsedLanguageDifferent = langInfo.iso !== ((_user$preferences = user.preferences) === null || _user$preferences === void 0 ? void 0 : _user$preferences.language.isoCode);
      const isUsedCurrencyDifferent = currencyCookieUppercase !== ((_user$preferences2 = user.preferences) === null || _user$preferences2 === void 0 ? void 0 : _user$preferences2.currency.code);
      if (isUsedCurrencyDifferent || isUsedLanguageDifferent) {
        return (0, _updateLocale.default)(token, {
          // Language code passed to mutation must have ISO value
          // language from langInfo contains value of currently used language in browser
          language: {
            code: langInfo.iso
          },
          currency: currencyCookieUppercase
        }).then(() => {
          return log(_events.ON_LOGIN_REGIONAL_SETTINGS_UPDATE, {});
        }).catch(err => {
          return log(_events.ON_LOGIN_REGIONAL_SETTINGS_ERROR, {
            error: String(err)
          });
        });
      }
    }
    return Promise.resolve();
  }, [langInfo.iso, log]);
  const onGetUserInfoAndLogin = React.useCallback(_ref2 => {
    let {
      token,
      refreshToken,
      shouldUpdateLocale = true
    } = _ref2;
    // Use Skyusers v2 endpoint
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (isSkyUsersV2) {
      return _store.store.getUserData().then(res => {
        if (res === null) {
          throw new Error("UNABLE TO FETCH USER DATA.");
        }
        return {
          type: "user",
          user: res,
          token,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, no-undefined
          refreshToken: !(0, _client.isWebview)() && refreshToken ? refreshToken : undefined
        };
      }).then(async auth => {
        onSetAuth(auth);
        setState("resolved");
        setLoading(false);
        await log(_events.LOGIN_USER_HAS_VALID_TOKEN, {});
        if (shouldUpdateLocale) {
          handleUpdateLocale(auth).catch(() => {});
        }
        return Promise.resolve();
      });
    }
    // Use Skyusers v1 endpoint
    return api
    // endpoint control here is needed for tequila usecase
    // tequila loads MMB in an iframe and they neeed to call different endpoint
    .getTokenUser(token, endpoint).then(user => ({
      type: "user",
      user,
      token
    })).then(async auth => {
      onSetAuth(auth);
      setState("resolved");
      setLoading(false);
      await log(_events.LOGIN_USER_HAS_VALID_TOKEN, {});
      if (shouldUpdateLocale) {
        handleUpdateLocale(auth).catch(() => {});
      }
      return Promise.resolve();
    });
  }, [endpoint, onSetAuth, log, handleUpdateLocale, isSkyUsersV2]);
  const handleGetAccessToken = React.useCallback(() => {
    return _store.store.getAccessToken();
  }, []);
  React.useEffect(() => {
    const initializeToken = async () => {
      const token = await handleGetAccessToken();
      if (token !== null) {
        (0, _cookies.remove)(_cookies.Cookie.SIMPLE_TOKEN);
      }
      if (typeof token === "string" && token !== (auth === null || auth === void 0 ? void 0 : auth.token)) {
        // Store the current token to ensure we're consistently using the same token throughout the async process
        const currentProcessingToken = token;
        setState("loading");
        setLoading(true);
        onGetUserInfoAndLogin({
          token: currentProcessingToken,
          shouldUpdateLocale: false
        }).catch(async error => {
          if (error instanceof api.TokenRetrievalError) {
            await log(_events.LOGIN_USER_TOKEN_RETRIEVAL_ERROR, {
              error: error.message
            });
          }
          if (error instanceof api.NetworkAbortError) {
            await log(_events.LOGIN_ABANDONED_REQUEST, {
              error: error.message
            });
          }
          if (error.message === _Auth.UnauthorizedReason.InvalidToken) {
            setState("resolved");
            setLoading(false);
            await log(_events.LOGIN_USER_HAS_INVALID_TOKEN, {});
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (isSkyUsersV2) {
              tokenFns.removeAuthTokens();
            } else {
              tokenFns.remove();
            }
            session.remove(_cookies.SessionStorage.ACCOUNT_ID);
            session.remove(_cookies.SessionStorage.EMAIL);
          }
        }).catch(err => {
          return Promise.reject(err);
        });
        return;
      }
      setState("resolved");
      const simpleTokenAuth = (0, _loadSimpleTokenAuth.default)();
      if (!token && simpleTokenAuth) {
        setAuth(simpleTokenAuth);
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    initializeToken();
    // auth.token is updated in onGetUserInfoAndLogin so we don't need to re-run this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [log, onGetUserInfoAndLogin, isSkyUsersV2, handleGetAccessToken]);
  const onCloseModal = React.useCallback(() => {
    if (typeof (modal === null || modal === void 0 ? void 0 : modal.onModalClose) === "function") {
      modal.onModalClose();
    }
    setModal(null);
  }, [modal]);
  const clearFbLocalStorage = () => {
    const fbLoginTokenRegex = /^fblst_\d+$/;
    for (const key in localStorage) {
      if (fbLoginTokenRegex.test(key)) {
        localStorage.removeItem(key);
      }
    }
  };
  const handleMyBooking = React.useCallback(input => {
    return api.getMyBookingToken(input).then(res => {
      if (onMyBooking) {
        onMyBooking(res.token);
      } else {
        window.location.assign(`/${langInfo.id}/manage/${res.bid}/${res.token}`);
      }
    }).catch(err => {
      return Promise.reject(err);
    });
  }, [langInfo.id, onMyBooking]);

  /**
   * @deprecated, passwords are not used with skyusers V2 and these old login and sign up flows will not be supported anymore
   */
  const handleRegister = React.useCallback(input => {
    return api.register(brand.id, input).then(() => {}).catch(err => {
      return Promise.reject(err);
    });
  }, [brand.id]);

  /**
   * @deprecated
   * @description Google login is now handled via redirect endpoint and no longer needs client-side SDKs
   * @see onOpenModal - Use this method instead
   * @example
   * // Instead of onGoogleAuth(), use:
   * onOpenModal({ initialScreen: "newIntroSignIn" | "newIntroSignUp"})
   *
   * // This handles both cases:
   * // - Webview: triggers native login
   * // - Browser: shows login modal with Google option as part of social logins
   *
   * @param {void}
   * @returns {Promise<void>}
   */
  const handleGoogleLogin = React.useCallback(() => {
    setState("loading");
    setLoading(true);
    return (0, _google.loginWithGoogleSDK)().then(googleRes => {
      if (googleRes.access_token) {
        return api.googleLogin(googleRes.access_token);
      }
      return Promise.reject(googleRes);
    }).then(res => {
      return onGetUserInfoAndLogin({
        token: res.token
      });
    }).catch(err => {
      return Promise.reject(err);
    }).finally(() => {
      setState("resolved");
      setLoading(false);
    });
  }, [onGetUserInfoAndLogin]);

  /**
   * @deprecated
   * @description Facebook login is now handled via redirect endpoint and no longer needs client-side SDKs
   * @see onOpenModal - Use this method instead
   * @example
   * // Instead of onFacebookAuth(), use:
   * onOpenModal({ initialScreen: "newIntroSignIn" | "newIntroSignUp"})
   *
   * // This handles both cases:
   * // - Webview: triggers native login
   * // - Browser: shows login modal with Facebook option as part of social logins
   *
   * @param {void}
   * @returns {Promise<void>}
   */
  const handleFacebookLogin = React.useCallback(() => {
    setState("loading");
    setLoading(true);
    return (0, _facebook.loginWithFacebookSDK)().then(facebookRes => {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (facebookRes.authResponse.accessToken) {
        return api.facebookLogin(facebookRes.authResponse.accessToken);
      }
      return Promise.reject(facebookRes);
    }).then(res => {
      return onGetUserInfoAndLogin({
        token: res.token
      });
    }).catch(err => {
      return Promise.reject(err);
    }).finally(() => {
      setState("resolved");
      setLoading(false);
    });
  }, [onGetUserInfoAndLogin]);

  /**
   * @deprecated
   * @description Apple login is now handled via redirect endpoint and no longer needs client-side SDKs
   * @see onOpenModal - Use this method instead
   * @example
   * // Instead of onAppleAuth(), use:
   * onOpenModal({ initialScreen: "newIntroSignIn" | "newIntroSignUp"})
   *
   * // This handles both cases:
   * // - Webview: triggers native login
   * // - Browser: shows login modal with Apple option as part of social logins
   *
   * @param {void}
   * @returns {Promise<void>}
   */
  const handleAppleLogin = React.useCallback(async () => {
    setState("loading");
    setLoading(true);
    await (0, _waitForVar.default)("AppleID").then(AppleID => {
      if (AppleID == null) {
        return Promise.reject(new Error("AppleID was not initialized."));
      }
      return AppleID.auth.init({
        clientId: "com.kiwi.prod",
        scope: "name email",
        redirectURI: window.origin,
        usePopup: true
      });
    }).catch(err => {
      throw err;
    }).finally(() => {
      setState("resolved");
      setLoading(false);
    });
    return AppleID.auth.signIn().then(appleRes => {
      if (appleRes.authorization.id_token) {
        setAppleIdToken(appleRes.authorization.id_token);
        return api.appleLogin(appleRes.authorization.id_token);
      }
      return Promise.reject(appleRes);
    }).then(res => {
      // this value represents if user already went through hidden email flow or didn't hide email
      if (!res.is_unconfirmed_private) {
        return onGetUserInfoAndLogin({
          token: res.token
        }).then(() => {
          return {
            connectAccount: false
          };
        });
      }
      setAppleUnconfirmedAuthToken(res.token);
      return {
        connectAccount: true
      };
    }).catch(err => {
      return Promise.reject(err);
    }).finally(() => {
      setState("resolved");
      setLoading(false);
    });
  }, [onGetUserInfoAndLogin]);

  /**
   * @deprecated, passwords are not used with skyusers V2 and these old login and sign up flows will not be supported anymore
   */
  const handleSignIn = React.useCallback((email, password) => {
    setState("loading");
    setLoading(true);
    return api.signIn({
      email,
      password,
      brand: brand.id
    }, endpoint).then(auth => {
      if (typeof auth.token === "string") {
        tokenFns.save(auth.token);
      }
      setState("resolved");
      setLoading(false);
      setAuth(auth);
      return auth;
    }).then(auth => {
      return handleUpdateLocale(auth);
    }).catch(err => {
      setState("resolved");
      setLoading(false);
      return Promise.reject(err);
    });
  }, [handleUpdateLocale, brand.id, endpoint]);

  /**
   * @deprecated, use logOut or the exported useGetLogout hook instead. This new method is backwards compatible with both V1 and V2 tokens, and it offers a callback for post-logout actions (onSuccessfullLogout).
   */
  const handleSignOut = React.useCallback(options => {
    var _options$invokeCallba;
    const invokeCallback = (_options$invokeCallba = options === null || options === void 0 ? void 0 : options.invokeCallback) !== null && _options$invokeCallba !== void 0 ? _options$invokeCallba : true;
    const token = auth === null || auth === void 0 ? void 0 : auth.token;
    session.remove(_cookies.SessionStorage.ACCOUNT_ID);
    session.remove(_cookies.SessionStorage.EMAIL);
    tokenFns.remove();
    (0, _cookies.remove)(_cookies.Cookie.SIMPLE_TOKEN);

    // clear out FB login access token from local storage
    clearFbLocalStorage();
    if ((auth === null || auth === void 0 ? void 0 : auth.type) === "token" && auth.bid) {
      _jsCookie.default.remove(`simple_token-${auth.bid}`);
    }
    setAuth(null);
    if (onSignOut && invokeCallback) {
      onSignOut();
    }

    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (token && typeof token === "string") {
      return api.logout(token);
    }
    return Promise.resolve();
  }, [onSignOut, auth]);
  const handleLogOut = React.useCallback(async options => {
    const onSuccessfullLogOut = options === null || options === void 0 ? void 0 : options.onSuccessfullLogOut;
    const token = auth === null || auth === void 0 ? void 0 : auth.token;
    (0, _cookies.remove)(_cookies.Cookie.SIMPLE_TOKEN);
    if ((auth === null || auth === void 0 ? void 0 : auth.type) === "token" && auth.bid) {
      _jsCookie.default.remove(`simple_token-${auth.bid}`);
    }
    if ((auth === null || auth === void 0 ? void 0 : auth.type) === "user" && auth.token) {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (isSkyUsersV2) {
        try {
          await _store.store.logout();
        } catch (error) {
          await log(_events.LOGOUT_ERROR, {
            error: String(error)
          });
        }
        // handle log out for Skyusers V1
      } else {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (token && typeof token === "string") {
          return api.logout(token);
        }
        tokenFns.remove();
      }
    }

    // clear out session cookies
    session.remove(_cookies.SessionStorage.ACCOUNT_ID);
    session.remove(_cookies.SessionStorage.EMAIL);
    // clear out FB login access token from local storage
    clearFbLocalStorage();
    setAuth(null);
    if (onSuccessfullLogOut) {
      onSuccessfullLogOut();
    }
    if (onSignOut) {
      onSignOut();
    }
    return Promise.resolve();
  }, [isSkyUsersV2, auth, log, onSignOut]);

  /* eslint-disable */
  const handleTurnstileReset = React.useCallback(() => {
    var _window;
    // safety check to be sure the turnstile is already present
    // we attach turnstile to window on when captcha widget is rendered
    // @ts-ignore
    if (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.turnstile) !== "undefined") {
      setTurnstileToken(null);
      // @ts-ignore
      window.turnstile.reset();
    } else {
      return log(_events.TURNSTILE_LOAD_FAILED, {});
    }
  }, [log]);
  const {
    postMessage
  } = (0, _webMessageSchemas.usePostMessageToMobileApp)() || {};

  /**
   * Opens auth modal or triggers native login based on environment
   * - Shows modal for requiredLogin screen regardless of environment
   * - In webview: triggers native login via postMessage
   * - In browser: shows modal with provided options
   */
  const onOpenModal = React.useCallback(options => {
    // Show modal for requiredLogin or when not in webview
    if ((options === null || options === void 0 ? void 0 : options.initialScreen) === "requiredLogin" || !(0, _client.isWebview)()) {
      setModal(options || {});
      return;
    }
    function onError(error, message) {
      log(_events.POST_MESSAGE_TO_APP_FAILED, {
        message: JSON.stringify(message.message),
        error: "Failed to post message: Mobile app interface not detected"
      }).catch(error => {
        throw Error(`Error occurred while logging POST_MESSAGE_TO_APP_FAILED: ${String(error)}`);
      });
    }

    // Trigger native login in webview
    const authMessage = {
      message: "sign-in",
      messagePayload: {
        url: window.location.href
      }
    };
    postMessage(authMessage, {
      onError
    });
  }, [postMessage, log]);
  const contextValue = React.useMemo(() => ({
    auth,
    loading,
    state,
    onMyBooking: handleMyBooking,
    onRegister: handleRegister,
    onFacebookAuth: handleFacebookLogin,
    onAppleAuth: handleAppleLogin,
    onGoogleAuth: handleGoogleLogin,
    onSignIn: handleSignIn,
    onSignOut: handleSignOut,
    logOut: handleLogOut,
    setAppleIdToken,
    modal,
    appleIdToken,
    appleUnconfirmedAuthToken,
    onCloseModal,
    onOpenModal,
    onSetAuth,
    onGetUserInfoAndLogin,
    isSkyUsersV2,
    disabledTurnstileAppId,
    setDisabledTurnstileAppId,
    turnstileToken,
    setTurnstileToken,
    onTurnstileReset: handleTurnstileReset
  }), [auth, handleMyBooking, appleIdToken, appleUnconfirmedAuthToken, handleRegister, handleSignIn, handleSignOut, handleLogOut, handleFacebookLogin, handleGoogleLogin, setAppleIdToken, loading, state, modal, onCloseModal, onOpenModal, onSetAuth, handleAppleLogin, onGetUserInfoAndLogin, isSkyUsersV2, disabledTurnstileAppId, setDisabledTurnstileAppId, turnstileToken, setTurnstileToken, handleTurnstileReset]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: contextValue,
    children: children
  });
};
exports.AuthProvider = AuthProvider;
const useAuth = () => React.useContext(context);
exports.useAuth = useAuth;
var _default = exports.default = context;
const useIsAuthResolved = () => {
  const {
    state
  } = useAuth();
  return state === "resolved";
};
exports.useIsAuthResolved = useIsAuthResolved;
const useGetAccessToken = () => {
  const {
    auth
  } = useAuth();
  return React.useCallback(_store.store.getAccessToken.bind(_store.store), [auth === null || auth === void 0 ? void 0 : auth.token]);
};
exports.useGetAccessToken = useGetAccessToken;
const useIsUserLoading = () => {
  const {
    loading
  } = useAuth();
  return loading;
};
exports.useIsUserLoading = useIsUserLoading;
const useUser = () => {
  const {
    auth
  } = useAuth();
  const [userData, setUserData] = React.useState(null);
  React.useEffect(() => {
    const wrapper = async () => {
      const userData = await _store.store.getUserData();
      setUserData(userData);
    };
    wrapper();
  }, [auth]);
  return userData;
};
exports.useUser = useUser;
const useIsModalOpen = () => {
  const {
    modal
  } = useAuth();
  return modal !== null;
};

/**
 * @deprecated, after implementing skyusers v2, we will not longer need to export this hook
 * please use useGetIsLoggedIn instead, it will return a async function that will check if the user is logged in
 */
exports.useIsModalOpen = useIsModalOpen;
const useIsSignedIn = () => {
  const {
    auth
  } = useAuth();
  return (auth === null || auth === void 0 ? void 0 : auth.type) === "user";
};

/**
 * @deprecated, Apple login is handled via redirect endpoint and we no longer need to export this apple auth hook
 * Please see handleAppleLogin for details
 */
exports.useIsSignedIn = useIsSignedIn;
const useAppleAuth = () => {
  const {
    appleIdToken,
    appleUnconfirmedAuthToken
  } = useAuth();
  return {
    appleIdToken,
    appleUnconfirmedAuthToken
  };
};
exports.useAppleAuth = useAppleAuth;
const useGetLogOut = () => {
  const {
    logOut
  } = useAuth();
  return logOut;
};
exports.useGetLogOut = useGetLogOut;
const useGetIsLoggedIn = () => {
  const getIsLoggedIn = async () => {
    const state = await _store.store.getState();
    return state === "loggedIn";
  };
  return getIsLoggedIn;
};
exports.useGetIsLoggedIn = useGetIsLoggedIn;
const useIsLoggedIn = () => {
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  const {
    isSkyUsersV2,
    state,
    auth
  } = useAuth();
  const {
    log
  } = (0, _context.useLog)();
  React.useEffect(() => {
    const checkLoginStatus = async () => {
      const state = await _store.store.getState();
      setIsLoggedIn(state === "loggedIn");
    };
    checkLoginStatus();
  }, [isSkyUsersV2, log, state, auth]);
  return isLoggedIn;
};
exports.useIsLoggedIn = useIsLoggedIn;